import _ from 'lodash';

import { THEME } from '../../constants/notification';
import { getMemberId } from '../../selectors/session/session';
import { membersService, organizationService } from '../../transport';
import { BI_SCHEMA } from '../../utils/bi-logger/bi-events';
import { biLoggerActionCreator } from '../../utils/bi-logger/bi-logger';
import i18n from '../../utils/i18n';

import { checkSession } from './login';

export const NAMES = {
  ORGANIZATIONS_GET_SUCCESS: 'ORGANIZATIONS.GET.SUCCESS',

  ORGANIZATION_CREATE_SUCCESS: 'ORGANIZATION.CREATE.SUCCESS',
  ORGANIZATION_CREATE_ERROR: 'ORGANIZATION.CREATE.ERROR',
  ORGANIZATION_CREATE_QUOTA_ERROR: 'ORGANIZATION.CREATE.QUOTA_ERROR',
  ORGANIZATION_CREATE_NAME_ERROR: 'ORGANIZATION.CREATE.NAME_ERROR',

  ORGANIZATION_UPDATE_SUCCESS: 'ORGANIZATION.UPDATE.SUCCESS',
  ORGANIZATION_GET_SUCCESS: 'ORGANIZATION.GET.SUCCESS',

  INVITE_ACCEPT_SUCCESS: 'ORGANIZATION.MEMBER.INVITE_ACCEPT.SUCCESS',
};

const getOrganizationsSuccess = (organizations) => ({
  type: NAMES.ORGANIZATIONS_GET_SUCCESS,
  payload: organizations,
});

const createOrganizationSuccess = (organization) => ({
  type: NAMES.ORGANIZATION_CREATE_SUCCESS,
  payload: organization,
});

const createOrganizationError = (organization) => ({
  type: NAMES.ORGANIZATION_CREATE_ERROR,
  payload: organization,
  notification: {
    message: i18n.t('notifications.organization.create.error'),
    theme: THEME.ERROR,
  },
});

const createOrganizationQuotaError = (organization) => ({
  type: NAMES.ORGANIZATION_CREATE_QUOTA_ERROR,
  payload: organization,
  notification: {
    message: i18n.t('notifications.organization.create.error.quota'),
    theme: THEME.ERROR,
  },
});

const createOrganizationNameError = (reason) => ({
  type: NAMES.ORGANIZATION_CREATE_NAME_ERROR,
  payload: reason,
});

const acceptInviteOrganizationSuccess = (invitation) => ({
  type: NAMES.INVITE_ACCEPT_SUCCESS,
  payload: invitation,
});

function isOrganizationQuotaError({ code, message }) {
  return code === 409 && message === 'organization quota exceeded';
}

function isOrganizationNameError({ code, message }) {
  return code === 409 && message === 'organization name taken';
}

export const createOrganization = (organization) => (dispatch) => {
  return (
    organizationService
      .createOrganization(organization)
      // TODO: FIX ME
      .then((response) => {
        return checkSession()(dispatch).then(() => response);
      })
      .then(
        (response) =>
          dispatch(createOrganizationSuccess(response.data.payload)),
        ({ response }) => {
          const data = _.get(response, 'data', {});

          if (isOrganizationNameError(data)) {
            dispatch(createOrganizationNameError(data));

            return Promise.reject({
              message: i18n.t(
                'onboarding.organization.new.organization-name-error-message',
              ),
              originalError: data,
            });
          }

          if (isOrganizationQuotaError(data)) {
            dispatch(createOrganizationQuotaError(data));
          } else {
            dispatch(createOrganizationError(data));
          }

          return Promise.reject(response);
        },
      )
  );
};

export const getMemberOrganizations =
  ({ memberId }) =>
  (dispatch) => {
    return membersService
      .getUserOrganizations({ memberId })
      .then((response) =>
        dispatch(getOrganizationsSuccess(response.data.payload)),
      );
  };

export const acceptInviteOrganization =
  (invitation) => (dispatch, getState) => {
    const state = getState();
    const memberId = getMemberId(state);
    const { organizationId } = invitation;

    return organizationService
      .acceptInviteOrganization({ organizationId })
      .then(() => getMemberOrganizations({ memberId })(dispatch))
      .then(() => dispatch(acceptInviteOrganizationSuccess(invitation)));
  };

export const sendCreateNewOrganizationClickBiEvent = () => {
  return biLoggerActionCreator({
    event: BI_SCHEMA.organizationSelectPage.createNewOrganization.click,
  });
};

export const sendSelectOrganizationSelectBiEvent = ({
  organizationName,
  organizationId,
}: {
  organizationName: string;
  organizationId: string;
}) => {
  return biLoggerActionCreator({
    event: BI_SCHEMA.organizationSelectPage.select.click,
    params: {
      organizationName,
      organizationId,
    },
  });
};
